export interface FunctionHeaderOptions {
  apikey: string;
  jwt?: string;
  partnerToken?: string;
}

export function buildFunctionHeaders(options: FunctionHeaderOptions): Record<string, string> {
  const { apikey, jwt, partnerToken } = options;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    apikey,
  };

  if (jwt) {
    headers.Authorization = `Bearer ${jwt}`;
  }

  if (partnerToken) {
    headers['x-partner-token'] = partnerToken;
  }

  return headers;
}
